import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <main className="min-h-screen flex items-center justify-center relative z-10 px-6">
      <div data-testid="payment-cancel-page" className="text-center max-w-lg">
        <XCircle className="w-16 h-16 text-[#8B8494] mx-auto mb-6" strokeWidth={1.2} />
        <h1 className="font-display text-5xl tracking-tight mb-4">Checkout cancelled</h1>
        <p className="text-[#57515F] mb-8">No charge was made. Your cart is saved whenever you&apos;re ready.</p>
        <Link to="/shop" data-testid="back-to-shop-cancel" className="btn-primary">Return to Shop</Link>
      </div>
    </main>
  );
}
